"use client";

import { useRef, useState, useEffect } from "react";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

const levels = [
    { id: "discover", key: "courses_tab_discover" },
    { id: "beginner", key: "courses_tab_beginner" },
    { id: "intermediate", key: "courses_tab_intermediate" },
    { id: "advanced", key: "courses_tab_advanced" },
];

export default function CoursesTabs({ level, category }) {
    const t = useTranslations();
    const scrollRef = useRef(null);
    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);

    const handleScroll = (e) => {
        const { scrollLeft, scrollWidth, clientWidth } = e.target;
        setIsAtStart(scrollLeft === 0);
        setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
    };

    // Vérification initiale lors du montage
    useEffect(() => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            setIsAtStart(scrollLeft === 0);
            setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
        }
    }, []);

    // Helper pour construire la query avec la catégorie si présente
    const buildQuery = (levelValue) => {
        const query = { level: levelValue };
        if (category) {
            query.category = category;
        }
        return query;
    };

    return (
        <div
            className={`gradient-wrapper relative mt-5 ${
                isAtStart ? "hide-left" : ""
            } ${isAtEnd ? "hide-right" : ""}`}
        >
            <div
                ref={scrollRef}
                onScroll={handleScroll}
                className="flex gap-2 overflow-x-auto pb-2 relative"
                style={{ scrollbarWidth: "none" }}
            >
                {levels.map((lvl) => {
                    const isActive = level === lvl.id;

                    return (
                        // Un bouton dans un lien est interdit par le modèle de
                        // contenu HTML, et l'arbre d'accessibilité annonçait
                        // deux fois chaque filtre. Le lien porte donc lui-même
                        // l'apparence. aria-current dit lequel est actif :
                        // jusqu'ici, seule la couleur le signalait.
                        <Link
                            key={lvl.id}
                            href={{
                                pathname: "/courses",
                                query: buildQuery(lvl.id),
                            }}
                            aria-current={isActive ? "page" : undefined}
                            className={`
                                flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm
                                transition-all duration-200 whitespace-nowrap
                                ${
                                    isActive
                                        ? "bg-primary !text-white shadow-md shadow-primary/25"
                                        : "bg-gray-100 dark:bg-white/5 text-gray-700 dark:text-grayDark-300 hover:bg-gray-200 dark:hover:bg-white/10"
                                }
                            `}
                        >
                            <span>{t(lvl.key)}</span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
